/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
import React, { useRef, useState } from 'react';
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import html2canvas from 'html2canvas';
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  Button,
} from '@mui/material';
import LoadingOverlay from '../components/LoadingOverlay';

export default function SLAGraph({ graphData, loading }) {
  const [loading1, setLoading1] = useState(false);
  const chartRef = useRef(null); // Reference to the container to be captured
  const updatedGraphData = graphData.map((item) => ({
    MonthName: item.FirstDayOfWeek,
    Quantity: parseInt(item.Quantity, 10),
    Percentage: parseFloat(item.Percentage),
  }));
  // const updatedGraphData = graphData.map((item) => ({
  //   MonthName: item.MonthName,
  //   Quantity: parseInt(item.Quantity, 10),
  //   Percentage: parseFloat(item.Percentage),
  // }));
  const downloadChart = async () => {
    setLoading1(true); // Set loading to true
    const chartElement = chartRef.current; // The chart's container
    if (chartElement) {
      // Scroll to the chart if it's off-screen
      chartElement.scrollIntoView({ behavior: 'smooth' });
      try {
        // Wait for the canvas to be created
        const canvas = await html2canvas(chartElement);
        // Proceed with download
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'chart.png'; // File name for download
        link.click();
      } catch (error) {
        console.log('Error capturing the chart:', error);
      } finally {
        // Set loading to false after the download is completed
        setLoading1(false);
      }
    } else {
      setLoading1(false);
    }
  };
  // FOR LEGEND CUSTUMISATION AND OTHER STYLING OF SAME
  const renderCustomLegend = (props) => {
    const { payload } = props;
    return (
      <ul style={{ display: 'flex', listStyle: 'none', padding: 0, justifyContent: 'center' }}>
        {payload.map((entry, index) => (
          <li
            key={`item-${index}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: 10,
              color: entry.color, // Keep the color from payload
            }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 32 32"
              style={{ marginRight: 4 }}
            >
              <rect fill={entry.color} width="32" height="32" />
            </svg>
            {/* Add a custom string based on the entry's value */}
            {entry.value === 'Quantity'
              ? entry.value
              : `${entry.value} % <= 2`} {/* Appending your custom string */}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: -6, mb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={downloadChart}
          disabled={loading1} // Disable button when loading
          startIcon={loading1 && <CircularProgress size={20} color="inherit" />}
        >
          {loading1 ? 'Downloading...' : 'Download Chart'}
        </Button>

      </Box>
      <Paper id="GraphContainer_id">
        {' '}
        {loading ? (
          <LoadingOverlay />
        ) : updatedGraphData.length !== 0 ? (
          <ResponsiveContainer width="100%" height="99%" ref={chartRef}>
            <ComposedChart
              data={updatedGraphData}
              margin={{
                top: 40,
                right: 20,
                bottom: 20,
                left: 10,
              }}
            >
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis
                dataKey="MonthName"
                // label={{
                //   value: 'Duration',
                //   position: 'insideBottomRight',
                //   offset: 0,
                // }}
              />
              <YAxis
                yAxisId="left"
                orientation="left"
                label={{
                  value: 'Quantity',
                  angle: -90,
                  position: 'insideLeft',
                  style: { fontWeight: 'bold' },
                }}
              />
              <YAxis
                yAxisId="right"
                orientation="right"
                domain={[0, 100]} // Fixed domain for Percentage
                label={{
                  value: 'Percentage(%)',
                  angle: -90,
                  position: 'outsideLeft',
                  style: { fontWeight: 'bold' },
                }}
              />
              <Tooltip />
              <Legend content={renderCustomLegend} />
              <Bar
                yAxisId="left"
                dataKey="Quantity"
                barSize={40}
                fill="#413ea0"
                label={({ x, y, width, value }) => (
                  <text
                    x={x + width / 2} // Centers the label horizontally
                    y={y - 10} // Adjusts the vertical position above the bar
                    fill="blue" // Text color
                    textAnchor="middle" // Centers the text
                    fontSize={14} // Adjust the font size
                    fontWeight="bold"
                  >
                    {value}
                  </text>
                )}
              />

              <Line
                yAxisId="right"
                type="monotone"
                dataKey="Percentage"
                stroke="#ff7300"
                label={({ x, y, value }) => (
                  <text
                    x={x}
                    y={y - 20} // Adjusts the vertical position above the line point
                    fill="red" // Text color
                    fontSize={16} // Adjust the font size
                    fontStyle="italic"
                    fontWeight="bold"
                  >
                    {value}%
                  </text>
                )}
              />

            </ComposedChart>
          </ResponsiveContainer>
        ) : (
          <Typography
            variant="h6"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20px',
            }}
          >
            No Data available!
          </Typography>
        )}
      </Paper>
    </>
  );
}
